<template>
  <v-tooltip class="tooltip" right>
    <template v-slot:activator="{ on, attrs }">
      <v-icon :class="class_def" color="white" small v-bind="attrs" v-on="on"
        >mdi-help-circle-outline</v-icon
      >
    </template>
    <div>
      <slot />
    </div>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    class_def: { default: "pb-6 px-2" },
  },
};
</script>
